import React from 'react'
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap'
import PageTemplate from 'components/page-template'

import Social from './social'

const ProfileSettings = () => (
  <PageTemplate
    title='Your Profile Settings'
    description='Change your settings'
  >
    <Tab.Container id='experiences' defaultActiveKey='social'>
      <Row className='clearfix'>
        <Col md={3}>
          <Nav bsStyle='pills' stacked>
            <NavItem eventKey='social'>Social</NavItem>
          </Nav>
        </Col>
        <Col md={9}>
          <Tab.Content animation>
            <Tab.Pane eventKey='social'>
              <Social />
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  </PageTemplate>
)

ProfileSettings.displayName = 'ProfileSettings'

export default ProfileSettings



// WEBPACK FOOTER //
// ./src/pages/profile-settings/index.js